import fetchApi from "../fetchApi";

export const CreateRole = async ({ name, description, permissions }) => {
  const body = { name };
  if (description) {
    body.description = description;
  }
  if (permissions) {
    body.permissions = permissions;
  }

  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(body),
    redirect: "follow",
  };

  return await fetchApi("roles", options);
};
